const ACTION_TYPES = {
  RECEIVED_CONNECTION_DATA: 'RECEIVED_CONNECTION_DATA',
  UPDATE_CONNECTION_DATA: 'UPDATE_CONNECTION_DATA',
  SAVE_CONNECTION_DATA: 'SAVE_CONNECTION_DATA',
  RESET_DATA: 'RESET_DATA',
};

export default ACTION_TYPES;
